import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.mixins.marginRight(theme.spacing(2)),
    backgroundColor: theme.mixins.White(),
    padding: `${theme.spacing(2.5)} ${theme.spacing(2)}`,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    width: pxToRem(270),
    [theme.breakpoints.up('lg')]: {
      ...theme.mixins.marginRight(theme.spacing(2.5)),
      padding: `${theme.spacing(3)} ${theme.spacing(4)}`,
      width: 'auto',
    },
    '& .description': {
      flexGrow: 1,
    },
  },
  description: {
    color: theme.palette.text.darkGrey,
    ...theme.palette.common.ellipsis(3),
  },
  bylabel: {
    padding: `0 ${pxToRem(2)}`,
  },
  reviewHeading: {
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.up('lg')]: {
      paddingBottom: theme.spacing(2),
    },
  },
  readMore: {
    color: theme.mixins.AbuDhabiOrange(),
  },
  reviewDate: {
    color: theme.palette.text.tertiary,
  },
  ratingImageWrapper: {
    height: 'auto',
    padding: `${theme.spacing(2)} 0 ${theme.spacing(1)} 0`,
    '& .ratingImage': {
      height: theme.spacing(2),
      width: 'auto',
      position: 'relative',
      ...theme.mixins.left(pxToRem(-12)),
      background: theme.palette.background.transparent,
    },
    '&.chinese-styles .ratingImage': {
      left: 0,
    },
  },
}));

export default useStyles;
